import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const FooterContentsComponentCopy = () => {
  const data = useSelector((state) => state.companyDetails);

  const [companyDetails, setCompanyDetails] = useState(data);
  const [companySocialMedia, setCompanySocialMedia] = useState([]);
  const [cmsPageFlag, setCmsPageFlag] = useState([]);

  useEffect(() => {
    if (data?.status) {
      setCompanyDetails(data.response);
      setCmsPageFlag(data?.response?.cmspageflag);
      try {
        if (data.response.userFrontSocialMediaVos) {
          setCompanySocialMedia(data.response.userFrontSocialMediaVos);
        } else {
          setCompanySocialMedia([]);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }, [data, companyDetails]);

  const FACEBOOK = "fab fa-facebook-f facebook-bg";
  const LINKEDIN = "fab fa-linkedin linkedin-bg";
  const GMAIL = "fab fa-google-plus-g google-bg";
  const YOUTUBE = "fab fa-youtube youtube-bg";
  const INSTAGRAM = "fab fa-instagram instagram-bg";

  let getSocialIconClass = (value) => {
    let content = "";
    switch (value) {
      case "facebook":
        content = FACEBOOK;
        break;
      case "linkedIn":
        content = LINKEDIN;
        break;
      case "gmail":
        content = GMAIL;
        break;
      case "youtube":
        content = YOUTUBE;
        break;
      case "instagram":
        content = INSTAGRAM;
        break;
      default:
        break;
    }

    return content;
  };

  function checkAnyCMSPagesFoundOrNot(cmsPageFlagList) {
    let sum = 0;
    for (let index = 0; index < cmsPageFlagList.length; index++) {
      if (cmsPageFlagList[index].AboutUs) {
        sum += cmsPageFlagList[index].AboutUs;
      }
      if (cmsPageFlagList[index].ContactUs) {
        sum += cmsPageFlagList[index].ContactUs;
      }
      if (cmsPageFlagList[index].privacyPolicy) {
        sum += cmsPageFlagList[index].privacyPolicy;
      }
      if (cmsPageFlagList[index].TermsAndCondition) {
        sum += cmsPageFlagList[index].TermsAndCondition;
      }
      if (cmsPageFlagList[index].ReturnPolicy) {
        sum += cmsPageFlagList[index].ReturnPolicy;
      }
    }
    return sum;
  }

  return (
    <div className="container">
      <div className="footer-content pt-3 pb-2">
        <div className="row justify-content-between">
          <div className="col-xl-3 col-lg-4 mb-50">
            <div className="footer-widget">
              <div className="footer-logo d-flex flex-column">
                <Link className="pe-2 mb-3" to="/" width="112" height="70">
                  <img
                    src={
                      companyDetails.logo
                        ? companyDetails.logo
                        : "/images/VasyERP.png"
                    }
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "images/VasyERP.png";
                    }}
                    alt="Company Logo"
                    className="img-fluid"
                    width="112"
                    height="70"
                  />
                </Link>
                <p className="company_description">
                  {companyDetails.description}
                </p>
              </div>
            </div>
            <div className="col-xl-2 col-lg-4 col-md-6 mb-30 d-flex flex-column followUsLink">
              <div className="d-flex flex-column">
                <h4
                  className="followUsHead"
                  hidden={companySocialMedia.length > 0 ? false : true}
                >
                  Follow Us
                </h4>
                <div className="footer-social-icon d-flex align-items-center">
                  {companySocialMedia.length > 0
                    ? companySocialMedia.map((socialMediaVo, index) => {
                        if (socialMediaVo.value) {
                          return (
                            <a
                              href={socialMediaVo.value}
                              key={socialMediaVo.type}
                              target="_blank"
                              aria-label={`Read more on ${socialMediaVo.type}`}
                            >
                              <i
                                className={
                                  "" +
                                  getSocialIconClass(socialMediaVo.type) +
                                  (socialMediaVo.type === "linkedIn"
                                    ? "linkedin"
                                    : socialMediaVo.type)
                                }
                              ></i>
                            </a>
                          );
                        } else {
                          return "";
                        }
                      })
                    : null}
                </div>
                {/* <div className="storeImage d-flex flex-row">
                  <div className="col-6 px-1">
                  <img src="./images/storeImage.png" />
                  </div>
                  <div className="col-6 px-1">
                  <img src="./images/appstoreImage.png" />
                  </div>
                </div> */}
              </div>
            </div>
          </div>
          <div className="col-xl-2 col-lg-4 col-md-6 mb-30">
            {cmsPageFlag.length > 0 && (
              <div className="footer-widget">
                <div className="footer-widget-heading">
                  <h3
                    hidden={
                      checkAnyCMSPagesFoundOrNot(cmsPageFlag) == 0
                        ? true
                        : false
                    }
                  >
                    Useful Links
                  </h3>
                </div>
                <ul className="d-flex flex-column">
                  {cmsPageFlag[1]?.ContactUs !== 0 && (
                    <li>
                      <Link to="/contact">Contact us</Link>
                    </li>
                  )}
                  {cmsPageFlag[2]?.privacyPolicy !== 0 && (
                    <li>
                      <Link to={"/privacy"}>Privacy Policy</Link>
                    </li>
                  )}
                  {cmsPageFlag[0]?.AboutUs !== 0 && (
                    <li>
                      <Link to="/about">About us</Link>
                    </li>
                  )}
                  {cmsPageFlag[3]?.TermsAndCondition !== 0 && (
                    <li>
                      <Link to="/terms">Terms & Conditions</Link>
                    </li>
                  )}
                  {cmsPageFlag[4]?.ReturnPolicy !== 0 && (
                    <li>
                      <Link to="/return-policy">Return Policy</Link>
                    </li>
                  )}
                </ul>
              </div>
            )}
          </div>
          {/* <div className="col-xl-2 col-lg-4 col-md-6 mb-30">
            <div className="footer-widget">
              <ul className="d-flex flex-column staticLinks">
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/categories">Shop By Categories</Link>
                </li>
              </ul>
            </div>
          </div> */}

          <div className="col-xl-3 col-lg-4 col-md-6 mb-30">
            <div className="contactCompanyBarContainer col-12 py-1">
              {companyDetails?.contactNo && (
                <div className="col-12 mb-30 justify-content-start align-items-start flex-column py-1">
                  <h4 className="m-0 contactCompanyHead">
                    {/* <i
                      className="fas fa-phone pe-2"
                      style={{ color: "#63A375" }}
                    ></i> */}
                    Contact Us
                  </h4>
                  <span className="fs-7 ps-1 company_contact">
                    <img src="/images/phone-contact.svg" />
                    <a href={`tel:` + companyDetails.contactNo}>
                      {companyDetails.contactNo}
                    </a>
                  </span>
                </div>
              )}
              {companyDetails?.address && (
                <div className="findUsBox col-12 mb-30 d-flex justify-content-start align-items-start flex-column py-1">
                  {/* <h4 className="m-0 contactCompanyHead">
                    <i
                      className="fas fa-map-marker-alt pe-2 "
                      style={{ color: "#FF220C" }}
                    ></i>
                    Find us
                  </h4> */}
                  <span className="fs-7">
                    {companyDetails.address}
                    {companyDetails.address && ","} {companyDetails.address2}
                  </span>
                </div>
              )}
              {companyDetails?.email && (
                <div className="col-12 mb-30 d-flex justify-content-start align-items-start flex-column py-1">
                  {/* <h4 className="m-0 contactCompanyHead">
                    <i
                      className="far fa-envelope-open pe-2"
                      style={{ color: "#3F88C5" }}
                    ></i>
                    Mail us
                  </h4> */}
                  <span className="fs-7 ps-1">
                    <a href={`mailto:` + companyDetails.email}>
                      e-mail: {companyDetails.email}
                    </a>
                  </span>
                </div>
              )}
            </div>
          </div>

          {/*
          <div className="col-xl-4 col-lg-4 col-md-6 mb-3 footer-contact-us">
            <div
              className="col-xl-12 col-md-12 mb-30 footerAddress"
              height="70"
            >
              <div className="single-cta d-flex">
                <i className="fas fa-map-marker-alt"></i>
                <div className="cta-text">
                  <h4>Find us</h4>
                  <span>{companyDetails.address}</span>
                  <span>
                    {companyDetails.address == "" ||
                    companyDetails.address == null
                      ? ""
                      : ", "}
                  </span>
                  <span>{companyDetails.address2}</span>
                </div>
              </div>
            </div>
            <div className="col-xl-12 col-md-12 my-3 footerContact" height="46">
              <div className="single-cta d-flex">
                <i className="fas fa-phone"></i>
                <div className="cta-text">
                  <h4>Call us</h4>
                  <span>
                    <a href={`tel:` + companyDetails.contactNo}>
                      {companyDetails.contactNo}
                    </a>
                  </span>
                </div>
              </div>
            </div>
            <div className="col-xl-12 col-md-12 my-3 footerContact" height="46">
              <div className="single-cta d-flex">
                <i className="far fa-envelope-open"></i>
                <div className="cta-text">
                  <h4>Mail us</h4>
                  <span>
                    <a href={`mailto:` + companyDetails.email}>
                      {companyDetails.email}
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </div>
          */}
        </div>
      </div>
    </div>
  );
};

export default FooterContentsComponentCopy;
